export default __webpack_public_path__ + "static/media/stats.0d5d80c0.svg";